module.exports = __webpack_public_path__ + "img/recharge(5).3973dcd1.png";